import AGENT_1_BURUBURU from './agent_1/agent_1_buruburu.mp3';
import AGENT_1_FURUFURU from './agent_1/agent_1_furufuru.mp3';
import AGENT_1_PATSUN from './agent_1/agent_1_patsun.mp3';
import AGENT_1_SCALE from './agent_1/agent_1_scale.mp3';
import AGENT_1_SHAKE from './agent_1/agent_1_shake.mp3';
import AGENT_1_YURERU_S from './agent_1/agent_1_yureru_s.mp3';
import AGENT_2_BURUBURU from './agent_2/agent_2_buruburu.mp3';
import AGENT_2_FURUFURU from './agent_2/agent_2_furufuru.mp3';
import AGENT_2_PATSUN from './agent_2/agent_2_patsun.mp3';
import AGENT_2_SCALE from './agent_2/agent_2_scale.mp3';
import AGENT_2_SHAKE from './agent_2/agent_2_shake.mp3';
import AGENT_2_YURERU_S from './agent_2/agent_2_yureru_s.mp3';
import AGENT_3_BURUBURU from './agent_3/agent_3_buruburu.mp3';
import AGENT_3_YURERU_ROLL from './agent_3/agent_3_yureru_roll.mp3';
import AGENT_4_BURUBURU from './agent_4/agent_4_buruburu.mp3';
import AGENT_4_FURUFURU from './agent_4/agent_4_furufuru.mp3';

import ECLIPSE from './drone/Eclipse.mp3';
import ECLIPSE_PLAIN from './drone/Eclipse_Plain.mp3';
import ENV_SIX from './drone/Env_Six.mp3';
import ENV_SEVEN from './drone/Env_Seven.mp3';
import ENV_EIGHT from './drone/Env_Eight.mp3';
import ENV_EIGHT_TB from './drone/Env_Eight_TB.mp3';
import ENV_STRINGS from './drone/Env_Strings.mp3';

import CONSTANTS from '../../constants/index';

const agentSounds = [
  { soundName: 'AGENT_1_BURUBURU', soundSource: AGENT_1_BURUBURU },
  { soundName: 'AGENT_1_FURUFURU', soundSource: AGENT_1_FURUFURU },
  { soundName: 'AGENT_1_PATSUN', soundSource: AGENT_1_PATSUN },
  { soundName: 'AGENT_1_SCALE', soundSource: AGENT_1_SCALE },
  { soundName: 'AGENT_1_SHAKE', soundSource: AGENT_1_SHAKE },
  { soundName: 'AGENT_1_YURERU_S', soundSource: AGENT_1_YURERU_S },
  { soundName: 'AGENT_2_BURUBURU', soundSource: AGENT_2_BURUBURU },
  { soundName: 'AGENT_2_FURUFURU', soundSource: AGENT_2_FURUFURU },
  { soundName: 'AGENT_2_PATSUN', soundSource: AGENT_2_PATSUN },
  { soundName: 'AGENT_2_SCALE', soundSource: AGENT_2_SCALE },
  { soundName: 'AGENT_2_SHAKE', soundSource: AGENT_2_SHAKE },
  { soundName: 'AGENT_2_YURERU_S', soundSource: AGENT_2_YURERU_S },
  { soundName: 'AGENT_3_BURUBURU', soundSource: AGENT_3_BURUBURU },
  { soundName: 'AGENT_3_YURERU_ROLL', soundSource: AGENT_3_YURERU_ROLL },
  { soundName: 'AGENT_4_BURUBURU', soundSource: AGENT_4_BURUBURU },
  { soundName: 'AGENT_4_FURUFURU', soundSource: AGENT_4_FURUFURU },
];

const droneSounds = (() => {
  if (window.innerWidth < CONSTANTS.TB_BREAK_POINT) {
    return [
      { soundName: 'ENV_SIX', soundSource: ENV_SIX },
      { soundName: 'ENV_EIGHT', soundSource: ENV_EIGHT_TB },
    ];
  }

  return [
    { soundName: 'ENV_SIX', soundSource: ENV_SIX },
    { soundName: 'ENV_SEVEN', soundSource: ENV_SEVEN },
    { soundName: 'ENV_EIGHT', soundSource: ENV_EIGHT },
  ];
})();

const effectSounds = (() => {
  if (window.innerWidth < CONSTANTS.TB_BREAK_POINT) {
    return [
      { soundName: 'ECLIPSE', soundSource: ECLIPSE_PLAIN },
      { soundName: 'ENV_STRINGS', soundSource: ENV_STRINGS },
    ];
  }

  return [
    { soundName: 'ECLIPSE', soundSource: ECLIPSE },
    { soundName: 'ENV_STRINGS', soundSource: ENV_STRINGS },
  ];
})();

export default {
  agentSounds,
  droneSounds,
  effectSounds,
};
